import React from 'react';
import Proptypes from 'prop-types';
import { checkIfHotjarEnable } from '../../../utils/helpers';
import Icon from '../../common/Svg/Svg';

const SinisterCard = ({
  customClasses,
  icon,
  altText,
  title,
  content,
  itemKey,
  relativeNum,
  onDetailClick,
  onLabelClick,
  isChecked,
  isNumberActive,
  detailsActive = true,
}) => {
  const onBtnClick = (e) => {
    if (checkIfHotjarEnable()) {
      window.digitalData.push({
        action: {
          group: 'Tramites Siniestros – Protección Tarjeta BBVA',
          category: 'Reporta siniestro',
          name: 'Ver detalle',
          label: title,
        },
        event: 'trackAction',
      });
    }
    onDetailClick(e, relativeNum);
  };

  const onLabelClickHandler = () => {
    onLabelClick();
  };

  return (
    <div className={'sinisterCard'}>
      <input
        readOnly
        className="checkbox"
        type="checkbox"
        name={`checkbox-${relativeNum}`}
        id={`checkbox-${relativeNum}`}
        checked={isChecked}
      />
      <div
        className={`sinisterCard__container ${
          customClasses ? customClasses : ''
        }`}
      >
        <label
          className="sinisterCard__description"
          onClick={onLabelClickHandler}
          htmlFor={`checkbox-${itemKey}`}
        >
          <div className="innerCont">
            <img className="icon" src={icon} alt={altText} />
            <div className="text">
              <div className="title u-mb-8">
                {relativeNum && isNumberActive ? (
                  <span>({relativeNum})</span>
                ) : (
                  ''
                )}
                <p>{title}</p>
              </div>
              <p className="content u-mb-16">{content}</p>
              {detailsActive && (
                <button onClick={onBtnClick} className="btn">
                  <p className="btn__text">Ver detalle</p>
                </button>
              )}
            </div>
          </div>
          <div className="check">
            <Icon name="checkOnly" />
          </div>
        </label>
      </div>
    </div>
  );
};

SinisterCard.propTypes = {
  icon: Proptypes.string.isRequired,
  altText: Proptypes.string.isRequired,
  content: Proptypes.oneOfType([Proptypes.string, Proptypes.element])
    .isRequired,
  itemKey: Proptypes.oneOfType([Proptypes.string, Proptypes.number]).isRequired,
};

export default SinisterCard;
